import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  LinearProgress
} from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import { Rating } from '@material-ui/lab'
import clsx from 'clsx'
import React, { useContext, useEffect, useState } from 'react'
import RTE from 'react-rte'
import stripHtml from 'string-strip-html'

import ToastMessages from '../../components/ToastMessages'
import { addOrEditHomeValidation, getHomeValidationsList } from '../../services/ClubeApi'
import { getLoggedUser, isAuthenticated } from '../../services/auth'

import Context from '../../context'
import ImageUploadToS3 from '../../services/ImageUpload'
import history from '../../services/history'

function HomeValidations() {
  const { setUser, setAboutCurrentPage, setOpenToast } = useContext(Context)
  const [data, setData] = useState(null)
  const [loading, setLoading] = useState(false)
  const [createModalData, setCreateModalData] = useState(null)
  const [deleteModalData, setDeleteModalData] = useState(null)
  const [photoPreview, setPhotoPreview] = useState(null)
  const classes = useStyles()

  useEffect(() => {
    if (!isAuthenticated()) return history.replace('/')

    setUser(getLoggedUser)
    getData()
    setAboutCurrentPage({
      title: 'Avaliações Home',
      buttons: [{ title: 'Nova avaliação', onClick: showAddModal }]
    })
  }, [])

  function changeCreateModalData(newData) {
    setCreateModalData(oldData => ({
      ...oldData,
      ...newData
    }))
    if (newData.photo) setPhotoPreview(URL.createObjectURL(newData.photo))
  }

  async function getData() {
    try {
      setLoading(true)
      let data = await getHomeValidationsList()
      setData(data)
    } catch {
      //
    } finally {
      setLoading(false)
    }
  }

  function showCreateModal(item) {
    return function () {
      setCreateModalData({
        ...item,
        description: RTE.createValueFromString(item.description, 'html')
      })
    }
  }
  const showAddModal = showCreateModal({
    name: '',
    photo: null,
    role: '',
    rating: 2.5,
    description: ''
  })

  function hideCreateModal() {
    setCreateModalData(null)
    setPhotoPreview(null)
  }

  function checkErrors(data) {
    if (!data.name.trim()) return 'Defina um nome'
    if (!data.photo) return 'Escolha uma foto'
    if (!data.role.trim()) return 'Defina um papel'
    if (!stripHtml(data.description.toString('html')).trim()) return 'Defina uma descrição'
    return null
  }

  async function createItem(item) {
    let error = checkErrors(item)
    if (error) {
      setOpenToast({
        open: true,
        message: error,
        type: 'error'
      })
      return
    }

    try {
      hideCreateModal()
      setData(null)
      setLoading(true)

      let photo =
        item.photo instanceof File
          ? await ImageUploadToS3(item.photo, 'images/home-validations/')
          : item.photo
      let description = item.description.toString('html')

      await addOrEditHomeValidation({
        ...item,
        photo,
        description
      })
      await getData()
    } catch {
      //
    }
  }

  function showDeleteModal(item) {
    return function () {
      setDeleteModalData(item)
    }
  }

  function hideDeleteModal() {
    setDeleteModalData(null)
  }

  async function deleteItem(item) {
    try {
      setDeleteModalData(null)
      setData(null)
      setLoading(true)
      await addOrEditHomeValidation({
        ...item,
        situation: 2
      })
      await getData()
    } catch {
      //
    }
  }

  return (
    <>
      <div className={classes.outerContainer}>
        <table className={classes.table}>
          <colgroup>
            <col className={classes.fitContent} />
            <col />
            <col className={classes.fitContent} />
          </colgroup>
          <thead>
            <tr>
              <td>Foto</td>
              <td>Nome</td>
              <td>Avaliação</td>
            </tr>
          </thead>
          <tbody>
            {!loading &&
              data?.map(item => (
                <tr key={item.id}>
                  <td>
                    <img
                      className={classes.photo}
                      src={process.env.REACT_APP_IMAGES_URL + item.photo}
                    />
                  </td>
                  <td className={classes.titleContainer}>
                    <div>{item.name}</div>
                    <div>
                      <a onClick={showCreateModal(item)}>Editar</a>
                      {' | '}
                      <a onClick={showDeleteModal(item)}>Excluir</a>
                    </div>
                  </td>
                  <td>
                    <Rating value={item.rating} precision={1} size="large" readOnly />
                  </td>
                </tr>
              ))}
            {!loading && data?.length === 0 && (
              <tr>
                <td colSpan="3">Nenhum resultado</td>
              </tr>
            )}
          </tbody>
        </table>
        {loading ? <LinearProgress style={{ marginTop: 30 }} /> : null}
      </div>

      <Dialog
        open={!!createModalData}
        onClose={hideCreateModal}
        transitionDuration={{ enter: 250, exit: 0 }}
        fullWidth
        maxWidth="md"
      >
        <DialogTitle>{createModalData?.id ? 'Editar' : 'Adicionar'} avaliação</DialogTitle>
        <DialogContent className={classes.main}>
          <div className={clsx(classes.inputGroup, classes.firstTwoRows)}>
            <span>Foto</span>
            <label
              className={classes.photoModal}
              style={{
                backgroundImage: `url("${
                  createModalData?.photo instanceof File
                    ? photoPreview
                    : process.env.REACT_APP_IMAGES_URL + createModalData?.photo
                }")`
              }}
            >
              <input
                type="file"
                onChange={e =>
                  changeCreateModalData({
                    photo: e.target.files[0]
                  })
                }
                accept="image/jpeg,image/png,image/gif"
              />
            </label>
          </div>
          <div className={clsx(classes.inputGroup, classes.secondColumn)}>
            <span>Nome</span>
            <input
              value={createModalData?.name}
              onChange={e =>
                changeCreateModalData({
                  name: e.target.value
                })
              }
            />
          </div>
          <div className={clsx(classes.inputGroup, classes.secondColumn)}>
            <span>Papel</span>
            <input
              value={createModalData?.role}
              onChange={e =>
                changeCreateModalData({
                  ...data,
                  role: e.target.value
                })
              }
              placeholder="e.g. Assinante do Clube"
            />
          </div>
          <div className={classes.inputGroup}>
            <span>Avaliação</span>
            <label className={classes.ratingContainer}>
              <Rating
                value={createModalData?.rating}
                onChange={(_, value) =>
                  changeCreateModalData({
                    ...data,
                    rating: value
                  })
                }
                precision={1}
                size="large"
              />
            </label>
          </div>
          {!!createModalData && (
            <div className={clsx(classes.inputGroup, classes.secondColumn)}>
              <span>Descrição</span>
              <div style={{ height: 'unset' }}>
                <RTE
                  className={classes.rte}
                  value={createModalData?.description}
                  onChange={value =>
                    changeCreateModalData({
                      ...data,
                      description: value
                    })
                  }
                  toolbarConfig={{
                    display: ['INLINE_STYLE_BUTTONS'],
                    INLINE_STYLE_BUTTONS: [
                      { label: 'Bold', style: 'BOLD' },
                      { label: 'Italic', style: 'ITALIC' },
                      { label: 'Underline', style: 'UNDERLINE' }
                    ]
                  }}
                />
              </div>
            </div>
          )}
        </DialogContent>
        <DialogActions>
          <Button color="primary" onClick={() => createItem(createModalData)}>
            Salvar
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={!!deleteModalData}
        onClose={hideDeleteModal}
        transitionDuration={{ enter: 250, exit: 0 }}
      >
        <DialogTitle>Excluir avaliação</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Deseja realmente excluir a avaliação de {deleteModalData?.name}?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button color="primary" onClick={hideDeleteModal}>
            Não
          </Button>
          <Button color="primary" onClick={() => deleteItem(deleteModalData)}>
            Sim
          </Button>
        </DialogActions>
      </Dialog>

      <ToastMessages />
    </>
  )
}

const useStyles = makeStyles({
  outerContainer: {
    display: 'flex',
    flexDirection: 'column',
    fontFamily: 'Montserrat',
    fontWeight: '500'
  },
  table: {
    marginTop: '20px',
    whiteSpace: 'nowrap',
    border: '2px solid #30287b',
    '& td': {
      border: '2px solid #30287b'
    },
    '& thead': {
      background: '#30287b'
    },
    '& thead td': {
      fontSize: '12px',
      padding: '17px 25px',
      fontWeight: '700',
      color: '#ffffff',
      lineHeight: '13px',
      textTransform: 'uppercase'
    },
    '& tbody td': {
      fontSize: '14px',
      padding: '17px 25px',
      color: '#30287b'
    }
  },
  fitContent: {
    width: 'fit-content'
  },
  titleContainer: {
    '& div:first-child': {
      marginBottom: '17px',
      fontWeight: '700'
    },
    '& div:last-child': {
      fontSize: '12px',
      '& a': {
        cursor: 'pointer'
      },
      '& a:not(:last-child)': {
        color: '#30287b'
      },
      '& a:last-child': {
        color: '#d73f32'
      }
    }
  },
  photo: {
    objectFit: 'cover',
    width: 80,
    height: 80,
    borderRadius: '50%'
  },
  photoModal: {
    alignSelf: 'center',
    objectFit: 'cover',
    width: '100%',
    height: 0,
    margin: 0,
    padding: '100% 0 0',
    background: '#eee center / cover',
    borderRadius: '50%',
    cursor: 'pointer'
  },
  inputGroup: {
    display: 'flex',
    flexDirection: 'column',
    position: 'relative',
    '& > span': {
      fontSize: '16px',
      fontWeight: 700,
      color: '#30287b'
    },
    '& > input, & > div, & textarea': {
      marginTop: '10px',
      background: '#fff',
      border: '2px solid #30287b !important'
    },
    '& input, & textarea': {
      padding: '11px 13px',
      fontSize: '14px',
      color: '#30287b',
      border: 'none'
    },
    '& > div': {
      display: 'flex',
      flexDirection: 'row'
    },
    '& > div input': {
      flexGrow: 1,
      height: '100%'
    },
    '& > input, & > div': {
      height: 44
    },
    '& textarea': {
      minHeight: 132,
      resize: 'none'
    },
    '& input[type="file"]': {
      opacity: 0,
      transform: 'scale(0)'
    }
  },
  main: {
    flexGrow: 1,
    display: 'grid',
    gridTemplateColumns: '160px auto',
    gap: '30px 60px'
  },
  rte: {
    width: '100%',
    minHeight: 140,
    border: 'none'
  },
  ratingContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center'
  },
  firstTwoRows: {
    gridRow: '1 / 3'
  },
  twoColumns: {
    gridColumn: '1 / 3'
  },
  secondColumn: {
    gridColumn: '2 / 3'
  }
})

export default HomeValidations
